import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, ReplaySubject } from "rxjs";
import { AppSettings } from "../../app.settings";
import { FinancialInstitution, IntegrationEventData, IntegrationEventType } from "./bank-account.model";
import { MatDialog } from "@angular/material/dialog";

import { BankAccountDecisionLogicDialogComponent } from './bank-account-decision-logic-dialog/bank-account-decision-logic-dialog.component';

declare global {
    interface Window {
        DecisionLogic: any;
    }
}

@Injectable({
    providedIn: 'root'
})

export class DecisionLogicService {

    private readonly baseUrl: string;
    private readonly PROVIDER_NAME = 'DecisionLogic';

    onIntegrationEvent: ReplaySubject<IntegrationEventData>;
    obsIntegrationEvent: Observable<IntegrationEventData>;

    constructor(
        private http: HttpClient,
        private dialog: MatDialog,
        private settings: AppSettings
    ) {
        this.baseUrl = `${this.settings.banking.url}`;
        this.onIntegrationEvent = new ReplaySubject<IntegrationEventData>(1);
        this.obsIntegrationEvent = this.onIntegrationEvent.asObservable();
    }

    open(entityId: number, institution: FinancialInstitution) {
        const createLinkTokenRequest = {
            entityId: entityId,
            institutionRoutingNumber: institution?.routingNumber
        };
        this.http.post<string>(`${this.baseUrl}/api/decision-logic/link-token`, createLinkTokenRequest)
            .subscribe(token => {
                this.openHandler(token, entityId, institution);
            },
            error => {
                this.onIntegrationEvent.next({
                    type: IntegrationEventType.Error,
                    provider: this.PROVIDER_NAME,
                    entityId: createLinkTokenRequest.entityId,
                    routingNumber: institution?.routingNumber,
                    institutionName: institution?.institutionName,
                    info: `decision-logic/link-token error: ${error}`
                })
            }
        );
        return
    }

    private openHandler(token: string, entityId: number, institution: FinancialInstitution) {
        BankAccountDecisionLogicDialogComponent.show(this.dialog, token)
        .subscribe(status => {
            if (status) {
                return this.onIntegrationEvent.next({
                    type: IntegrationEventType.Success,
                    provider: this.PROVIDER_NAME,
                    entityId: entityId,
                    routingNumber: institution?.routingNumber,
                    institutionName: institution?.institutionName,
                    info: null
                });
            }
            this.onIntegrationEvent.next({
                type: IntegrationEventType.Error,
                provider: this.PROVIDER_NAME,
                entityId: entityId,
                routingNumber: institution?.routingNumber,
                institutionName: institution?.institutionName,
                info: `decision-logic/link-token error: user terminated interaction`
            })
        });
    }
}
